// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"588":"7d69b004","614":"a8a8cf19"}[chunkId] + ".chunk.css";
};